import { useQuery } from "@tanstack/react-query";
import { from, unwrap } from "@vixio/data";
import type { QueueHealth } from "./api";

/** Dados dos painéis do Início: ficam fora das telas para que elas carreguem sob demanda. */
export function useQueueHealth(orgId: string) {
  return useQuery({
    queryKey: ["notifications", "health", orgId],
    refetchInterval: 15_000,
    queryFn: async () => (await unwrap<QueueHealth[]>(from("notifications", "v_queue_health").select("*").eq("org_id", orgId)))[0] ?? null,
  });
}
